import { mount } from "svelte";
import App from "./App.svelte";
import ConfigError from "./components/ConfigError.svelte";
import { loadConfig } from "./lib/config";
import { applyTheme } from "./lib/theme";
import "./lib/styles/tokens.css";

const target = document.getElementById("app");
if (!target) {
  throw new Error("Missing #app root element");
}

(async () => {
  try {
    const cfg = await loadConfig();
    applyTheme(cfg.theme);
    if (cfg.tenantLabel) document.title = cfg.tenantLabel;
    mount(App, { target });
  } catch (e) {
    applyTheme("auto");
    mount(ConfigError, {
      target,
      props: { message: (e as Error).message ?? String(e) },
    });
  }
})();
